import {Stack} from '@mui/material';
import SessionQuestionAnswerListChoice from './SessionQuestionAnswerListChoice';
import {SessionQuestion} from '@cp/model';

export interface SessionQuestionAnswerListProps {
  currentQuestion: SessionQuestion;
  selectedAnswer: string;
  handleAnswerSelect: (answer: string) => void;
  disabled: boolean;
}

export default function SessionQuestionAnswerList({
  currentQuestion,
  selectedAnswer,
  handleAnswerSelect,
  disabled,
}: SessionQuestionAnswerListProps) {
  return (
    <Stack spacing={2}>
      {currentQuestion.options.map((option) => (
        <SessionQuestionAnswerListChoice
          key={`${currentQuestion.id}-option-${option}`}
          text={option}
          isSelected={selectedAnswer === option}
          handleAnswerSelect={handleAnswerSelect}
          disabled={disabled}
        />
      ))}
    </Stack>
  );
}
